export interface AuthCallbackParams {
  access_token?: string;
  refresh_token?: string;
  code?: string;
  [key: string]: string | undefined;
}

export function parseAuthParamsFromUrl(rawUrl: string): AuthCallbackParams {
  const params: AuthCallbackParams = {};
  try {
    const parsed = new URL(rawUrl);
    parsed.searchParams.forEach((value, key) => {
      params[key] = value;
    });
    readHashParams(parsed.hash).forEach((value, key) => {
      params[key] = value;
    });
  } catch {
    return params;
  }
  return params;
}

function readHashParams(hash: string): Map<string, string> {
  const params = new Map<string, string>();
  const fragment = hash.startsWith("#") ? hash.slice(1) : hash;
  if (!fragment) return params;

  fragment.split("&").forEach((pair) => {
    const eqIndex = pair.indexOf("=");
    const rawKey = eqIndex === -1 ? pair : pair.slice(0, eqIndex);
    const rawValue = eqIndex === -1 ? "" : pair.slice(eqIndex + 1);
    if (!rawKey) return;
    params.set(safeDecode(rawKey), safeDecode(rawValue));
  });
  return params;
}

function safeDecode(value: string): string {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}
